/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
	'expenseCategories/car-bank': {
		width: 35,
		height: 36,
		viewBox: '0 0 35.4 36.1',
		data: `<g id="_x37_9888d52-1ee7-4106-807c-99717aeecfe8" transform="matrix(1, 0, 0, 1, 540, 540)">
    </g>
    <g>
      <path class="st0" d="M33.9,10.4c0.8,0,1.5-0.9,1.5-1.7V7.1c0-0.7-0.4-1.2-1.1-1.5l-9.7-5.5c-0.4-0.1-1.1-0.1-1.5,0l-9.8,5.6
        c-0.5,0.3-0.8,0.9-0.8,1.5v1.6c0,0.8,0.7,1.5,1.5,1.5h0.8v7.3H17v-7.1h13.7h0.1v9.2h-3.5v-6.9H25v6.9h-2.3v-6.9h-2.3v6.9h-1.9
        l0.7,2.3h14.9c0.7,0,1.2-0.7,1.2-1.2s-0.5-1.1-1.1-1.2H33v-9.2H33.9L33.9,10.4z M14.7,7.9V7.5l9.2-5.2l9.2,5.2v0.4H14.7z"/>
      <path class="st0" d="M23.9,4.5c-0.7,0-1.2,0.5-1.2,1.2s0.7,1.2,1.2,1.2s1.2-0.5,1.2-1.2S24.6,4.5,23.9,4.5z"/>
    </g>
    <g transform="matrix(1, 0, 0, 1, 12.0600233078, 25.596286773682)">
      <path vector-effect="non-scaling-stroke" class="st0" d="M10.2-2.8L8.6-8.4C8.2-9.7,7-10.6,5.7-10.6H-5.7c-1.3,0-2.5,0.9-2.9,2.1
        l-1.7,5.6c-1.1,0.5-1.8,1.6-1.8,2.8v6c0,0.8,0.7,1.5,1.5,1.5V9c0,0.4,0.1,0.8,0.4,1.1c0.3,0.3,0.7,0.5,1.1,0.5h1.5
        c0.4,0,0.8-0.2,1.1-0.5C-6.2,9.8-6,9.4-6,9V7.5H6.1V9c0,0.4,0.2,0.8,0.4,1.1c0.3,0.3,0.7,0.4,1.1,0.4h1.5c0.8,0,1.5-0.7,1.5-1.5
        V7.5c0.4,0,0.8-0.2,1.1-0.5s0.4-0.7,0.4-1.1V0C12.1-1.2,11.3-2.3,10.2-2.8z M-5.7-7.5H5.7L7.1-3h-14L-5.7-7.5z M-6,3.8
        c-0.8,0-1.5-0.7-1.5-1.5S-6.9,0.7-6,0.7s1.5,0.7,1.5,1.5C-4.5,3.1-5.2,3.8-6,3.8z M6,3.8c-0.8,0-1.5-0.7-1.5-1.5S5.2,0.7,6,0.7
        s1.5,0.7,1.5,1.5C7.5,3.1,6.9,3.7,6,3.8L6,3.8z"/>
    </g>`
	}
});
